
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useIsMobile } from "@/hooks/use-mobile";
import { Separator } from "./ui/separator";
import { SAFELIGHT_DESCRIPTION } from "@/App";
import { useDarkroomMode } from "@/hooks/useDarkroomMode";
import { cn } from "@/lib/utils";

export const SiteFooter = () => {
  const isMobile = useIsMobile();
  const location = useLocation();
  const currentYear = new Date().getFullYear();
  const { darkroomMode } = useDarkroomMode();
  
  // Check if we should hide the footer on mobile
  const isHomePage = location.pathname === '/' || location.pathname === '/dashboard';
  const shouldHideFooter = isMobile && !isHomePage;
  
  if (shouldHideFooter) {
    return null; // Don't render the footer on mobile unless on home page
  }
  
  return (
    <footer className={cn(
      "border-t mt-8",
      darkroomMode && "darkroom-footer"
    )}>
      <div className={`container mx-auto py-6 ${isMobile ? 'px-3' : 'px-4'}`}>
        <div className="flex flex-col md:flex-row items-center justify-between">
          <p className={cn(
            "text-xs text-muted-foreground",
            darkroomMode && "text-red-500"
          )}>
            © {currentYear} Safelight Project. All rights reserved.
          </p>
          <div className="flex items-center space-x-4 mt-4 md:mt-0">
            <Link to="/" className={cn(
              "text-xs text-muted-foreground hover:text-foreground transition-colors",
              darkroomMode && "text-red-500 hover:text-red-400"
            )}>
              Home
            </Link>
            <Link to="/about" className={cn(
              "text-xs text-muted-foreground hover:text-foreground transition-colors",
              darkroomMode && "text-red-500 hover:text-red-400"
            )}>
              About
            </Link>
            <Link to="/contact" className={cn(
              "text-xs text-muted-foreground hover:text-foreground transition-colors",
              darkroomMode && "text-red-500 hover:text-red-400"
            )}>
              Contact
            </Link>
            <Link to="/resources" className={cn(
              "text-xs text-muted-foreground hover:text-foreground transition-colors",
              darkroomMode && "text-red-500 hover:text-red-400"
            )}>
              Resources
            </Link>
            <Link to="/privacy" className={cn(
              "text-xs text-muted-foreground hover:text-foreground transition-colors",
              darkroomMode && "text-red-500 hover:text-red-400"
            )}>
              Privacy
            </Link>
            <Link to="/terms" className={cn(
              "text-xs text-muted-foreground hover:text-foreground transition-colors",
              darkroomMode && "text-red-500 hover:text-red-400"
            )}>
              Terms
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
